import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {UserVerificationService} from "../services/user-verification.service";
import { Subscription } from 'rxjs';
import {NgForm} from "@angular/forms";
import {KeycloakService} from "../services/keycloak.service";
import {HttpService} from "../services/http.service";
import {ApiEndpoints} from "../services/api-endpoints";
import {StringUtils} from "../services/string-utils";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-get-all-join-servers-detail',
  templateUrl: './get-all-join-servers-detail.component.html',
})
export class GetAllJoinServersDetailComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  id: any;
  listInfo: Object = {};
  listStatus: Object;

  listServedNetworkServers: any[];
  public authTypes: string[] = ['None', 'BasicAuth']

  hasAcces: boolean;

  errorStatus: number;
  errorText: string;

  public nsName;
  public strOwnership = "";
  public userUrl = ApiEndpoints.GET_USER;
  public logsUrl = ApiEndpoints.GET_JOIN_SERVER_LOGS;

  httpSubscription: Subscription;

  public statusRefreshing = false;

  @ViewChild('validate') validate: NgForm;
  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              private userVerificationService: UserVerificationService,
              private httpService: HttpService) {

    this.isAdmin = this.userVerificationService.isAdmin;

    //get URL parameters virtId
    this.route.params.subscribe(params => {
      this.id = params['virtId']
    });

    this.httpSubscription = this.httpService.getJoinInfo(this.id).subscribe(data => {
        this.listInfo = data;
        if (data.username == 'Default') {
          this.username = '';
        } else {
          this.username = data.username;
          if (data.affiliation !== undefined && data.affiliation !=="") {
            this.strOwnership = data.username + ' / ' + data.affiliation;
          } else {
            this.strOwnership = data.username;
          }
        }
        this.hasAcces = true;
        this.getAllJoinServerDetails();
        this.getJoinServiceName(data.name);
      }
      , (err) => {
        this.hasAcces = false;
        this.errorStatus = err.status;
        this.errorText = err.statusText;
      });
  }

  getJoinServiceName(joinName) {
    var serverName = joinName;
    var html = '<div class="collapse show width-100-perc" id="menu2sub1"><a class="list-group-item transition item-sub sub active" data-parent="#menu2sub1">' + serverName + '</a></div>';
    $(".join-servers").after(html);
  }

  getAllJoinServerDetails() {
    this.getStatus(this.id);
  }

  getStatus(id) {
    this.listStatus = {};
    var body: any = {"virtId": id};
    var url = ApiEndpoints.GET_JOIN_SERVER_STATUS;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.listStatus = data;
        }
      );
  }

  // refresh components
  refreshStatus() {
    this.listStatus = {};
    this.statusRefreshing = true;
    var bodyStatus: any = {"virtId": this.id};
    var urlStatus = ApiEndpoints.GET_JOIN_SERVER_STATUS;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    this.http.post<any>(urlStatus, bodyStatus, options).subscribe(
        data => {
          this.listStatus = data
          this.statusRefreshing = false;
        }
      );
  }

  parseServedNetworkServersList(listServedNetworkServers) {
    listServedNetworkServers.forEach(servedNetworkServer => {
      servedNetworkServer.netIds = StringUtils.insertSpacesBetweenIds(servedNetworkServer.netIds);
    });
    return listServedNetworkServers;
  }

  ngOnInit() {
    $(document).on("click", ".join-servers", function (e) {
      $("#menu1sub1").remove();
      $("#menu2sub1").remove();
      $("#menu1").removeClass("show");
    });
  }

  servedNetworkServersLoaded(servedNSs) {
    this.listServedNetworkServers = servedNSs;

  }


  ngOnDestroy() {
    $("#menu2sub1").removeClass("show");
  }
}
